{
  "draw": 41478,
  "drawElements": 28248,
  "drawInstanced": 52852,
  "multiDraw": 262144,
  "uniformUpdates": 99297,
  "uboUpdates": 1019,
  "bindTextureSwitch": 26426,
  "useProgramSwitch": 13430,
  "bindVAOSwitch": 12459,
  "vertexAttribSetup": 48907,
  "stateChange": 14629,
  "viewportScissor": 11787,
  "fboSwitch": 133,
  "bufferSubDataSmall": 26006,
  "bufferSubDataBig": 60,
  "texSubImageSmall": 799,
  "texSubImageBig": 64,
  "texImageFromDOM": 78,
  "readPixelsSync": 16,
  "syncRoundTrip": 127,
  "createDeleteBuffers": 1205,
  "createDeleteTextures": 143
}
